export const DATE_RANGE = 'Date Range';
